_setUserDataLanguageAlertBarAcceptedThunk